module.exports = __webpack_public_path__ + "09c8d441063d09c47ea7d2cffc968d41.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/mail_reminder.png
// module id = 1560
// module chunks = 0